export const viguideVersion = '2.55.0';
